import ServiceDetailPage from '../components/services/ServiceDetailPage';
import { getServicePageConfig } from '../data/services/servicesRegistry';

const QualityTestingService = () => (
  <ServiceDetailPage {...getServicePageConfig('qualityTesting')} />
);

export default QualityTestingService;
